import cohortsActionTypes from './actionTypes';
import { createAsyncRequestReducer } from '../../util/fetchReducers';
// @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
import createReducer from '../../util/createReducer';
import { combineReducers } from 'redux';

const createCohortFailure = (newState: any, action: any) => {
  return {
    ...newState,
    response: action.response,
  };
};

export const reducers = {
  query: createAsyncRequestReducer(cohortsActionTypes.FETCH_COHORTS),
  createCohort: createAsyncRequestReducer(cohortsActionTypes.CREATE_COHORT, {
    asyncReducers: {
      failure: createCohortFailure,
    },
  }),
  selected: createReducer(
    { activeProjectCohort: null },
    {
      [cohortsActionTypes.SET_ACTIVE_COHORT]: (state: any, action: any) => {
        return {
          ...state,
          activeCohort: action.id,
        };
      },
    },
  ),
  multipleSelected: createReducer(
    { activeProjectCohort: [] },
    {
      [cohortsActionTypes.SET_SELECTED_COHORTS]: (state: any, action: any) => {
        return {
          ...state,
          selectedCohorts: action.ids,
        };
      },
    },
  ),
};

export default combineReducers(reducers);
